// removed by extract-text-webpack-plugin
module.exports = {"component":"_2yFVX0DU2H_uLU-boo2VrG","jsdd":"_3W5TBx3AnK7NUZixNIOiSH","border":"_2j8mgH5cZmMI8wLKwVHkHt","allTable":"_3osrNhJD1UwQK-UCGHRIU-","bttn":"_2aWqO_1In4Bz82emLnj7Z1","quanxuan":"ZoLm38aFi3g8reZKaYZJe","rightBtn":"_20gxRJvAT27XX5_qmt2fAp","linkb":"_3x1HaSVAHEeQV44xHwY2eq","sumbitBtn":"_3So2LqKAUQ5BRpXE5FMOrn"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ExperienceShopPromotion/ExperienceShopPromotion.scss
 ** module id = 1065
 ** module chunks = 0
 **/